// extracted by mini-css-extract-plugin
module.exports = {"root":"StoryEditor__root--2BoRU","container":"StoryEditor__container--ggPpp","top":"StoryEditor__top--1ajs8","input":"StoryEditor__input--3fk-R"};